import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import Button from "../../../../../components/button/Button";
import Icon from "../../../../../components/icon/Icon";
import RadioButton from "../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../components/textbox/Input";
import OggettiUtili from "../../../../../utils/OggettiUtili";
import Utils from "../../../../../utils/Utils";
import Autocomplete from "../../../../../components/autocomplete/Autocomplete";
import {withTranslation} from "react-i18next";
import Select from "../../../../../components/select/Select"


class Veicolo extends Component {
    state = {
        veicolo: {
            presenza: this.props.malattiePremal.includes(this.props.malattia)? "2*" : "",
            corretto: [],
            tipologiaVeicolo: [
                {
                    tipologia: "",
                    livelloCertezzaTipo: "",
                    veicolo: [{
                        veicolo: "",
                        veicoloAltro: "",
                        livelloCertezza: "",
                        paeseOrigine: ""
                    }
                    ]
                }
            ],
        },
        clickVeicolo: [0, 0],
        boxesVeicolo: [[]],
        boxesTipologia: [],
        clickTipologia: 0,
        listaTipologiaVeicolo: [[]],
        listaVeicoli: [[]],

        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),
    }

    constructor(props) {
        super(props);
        this.aggiungiTipologia = this.aggiungiTipologia.bind(this);
        this.aggiungiTipologiaStato = this.aggiungiTipologiaStato.bind(this);
        this.aggiungiVeicoloStato = this.aggiungiVeicoloStato.bind(this);
        this.aggiungiVeicolo = this.aggiungiVeicolo.bind(this);
        this.handleChangeTipoVeicolo = this.handleChangeTipoVeicolo.bind(this);
        this.handleChangeLivelloCertezzaTipologiaVeicolo = this.handleChangeLivelloCertezzaTipologiaVeicolo.bind(this);
        this.handleChangeVeicolo = this.handleChangeVeicolo.bind(this)
        this.loadSelectVeicolo = this.loadSelectVeicolo.bind(this)
        this.handleChangeLivelloCertezzaVeicolo = this.handleChangeLivelloCertezzaVeicolo.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
        this.setPresenzaVeicolo = this.setPresenzaVeicolo.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.loadTipologiaVeicoli = this.loadTipologiaVeicoli.bind(this)
        this.validate = this.validate.bind(this)
        this.uniqueObjectVeicolo = this.uniqueObjectVeicolo.bind(this)
        this.loadSelectVeicoloCertezzaTipologia = this.loadSelectVeicoloCertezzaTipologia.bind(this)
    }

    componentDidMount() {
        this.props.setVeicolo(undefined, this, undefined)
        if (this.props.segnalazioneDatiSpecificiCopia.datiSpecifici &&
            this.props.segnalazioneDatiSpecificiCopia.datiSpecifici.veicolo) {
            let veicoloCopia = JSON.parse(JSON.stringify(this.props.segnalazioneDatiSpecificiCopia.datiSpecifici.veicolo));
            let veicolo = this.state.veicolo
            veicolo.presenza = veicoloCopia.presenza
            veicolo.corretto = veicoloCopia.corretto;
            if (veicoloCopia.tipologiaVeicolo || veicoloCopia.tipologiaVeicolo != null || veicoloCopia.tipologiaVeicolo != undefined) {
                for (let i = 0; i < veicoloCopia.tipologiaVeicolo.length; i++) {
                    veicolo.tipologiaVeicolo[i] = veicoloCopia.tipologiaVeicolo[i] ? veicoloCopia.tipologiaVeicolo[i] : this.state.veicolo.tipologiaVeicolo
                    veicolo.tipologiaVeicolo[i].tipologia = veicoloCopia.tipologiaVeicolo[i].tipologia ? veicoloCopia.tipologiaVeicolo[i].tipologia : ""
                    veicolo.tipologiaVeicolo[i].livelloCertezzaTipo = veicoloCopia.tipologiaVeicolo[i].livelloCertezzaTipo ? veicoloCopia.tipologiaVeicolo[i].livelloCertezzaTipo : ""
                    veicolo.tipologiaVeicolo[i].veicolo = veicoloCopia.tipologiaVeicolo[i].veicolo ? veicoloCopia.tipologiaVeicolo[i].veicolo : []
                    if (veicolo.tipologiaVeicolo[i].veicolo.length == 0) {
                        let newVeicolo = {
                            veicolo: "",
                            veicoloAltro: "",
                            livelloCertezza: "",
                            paeseOrigine: ""
                        }
                        veicolo.tipologiaVeicolo[i].veicolo.push(newVeicolo)
                    }

                    if (veicoloCopia.tipologiaVeicolo[i].veicolo) {
                        for (let j = 0; j < veicoloCopia.tipologiaVeicolo[i].veicolo.length; j++) {
                            veicolo.tipologiaVeicolo[i].veicolo[j].veicolo = veicoloCopia.tipologiaVeicolo[i].veicolo[j].veicolo ? veicoloCopia.tipologiaVeicolo[i].veicolo[j].veicolo : "";
                            veicolo.tipologiaVeicolo[i].veicolo[j].veicoloAltro = veicoloCopia.tipologiaVeicolo[i].veicolo[j].veicoloAltro ? veicoloCopia.tipologiaVeicolo[i].veicolo[j].veicoloAltro : "";
                            veicolo.tipologiaVeicolo[i].veicolo[j].livelloCertezza = veicoloCopia.tipologiaVeicolo[i].veicolo[j].livelloCertezza ? veicoloCopia.tipologiaVeicolo[i].veicolo[j].livelloCertezza : "";
                            veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine = veicoloCopia.tipologiaVeicolo[i].veicolo[j].paeseOrigine ?
                                this.state.nazioniPerCodice[veicoloCopia.tipologiaVeicolo[i].veicolo[j].paeseOrigine] : "";
                        }
                    } else {
                        this.aggiungiVeicolo(0)
                        this.aggiungiTipologia();
                    }

                }
            }
            this.setState({veicolo: veicolo})
            let click = 0
            for (let i = 0; i < this.state.veicolo.tipologiaVeicolo.length; i++) {
                if (this.state.veicolo.tipologiaVeicolo[i].veicolo) {
                    for (let j = 0; j < this.state.veicolo.tipologiaVeicolo[i].veicolo.length; j++) {
                        this.loadSelectVeicolo(this.state.veicolo.tipologiaVeicolo[i].tipologia, i);
                    }
                }
                this.loadTipologiaVeicoli(i)
                click++
                this.aggiungiTipologia(click)
            }
        } else {
            this.loadTipologiaVeicoli(0);
            this.aggiungiVeicolo(0)
            this.aggiungiTipologia();
        }

        this.controlloCorrettezza()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevState.clickTipologia > this.state.clickTipologia) {
            this.aggiungiTipologia();
        }
        if (Utils.areObjectsEquivalent(prevState.veicolo, this.state.veicolo)) {
            let objFinal = this.createJsonForBackend()
            this.props.setVeicolo(this.state.veicolo, this, objFinal)
        }
    }

    loadTipologiaVeicoli(indice) {
        const params = ['codiceVeicolo', 'descrizioneVeicolo']
        let listaTipologiaVeicolo = this.state.listaTipologiaVeicolo
        if (listaTipologiaVeicolo && this.props.infoMalattia) {
            listaTipologiaVeicolo.splice(indice, 1, Utils.tipi(this.props.infoMalattia, params))
            this.setState({listaTipologiaVeicolo: listaTipologiaVeicolo})
        }

    }

    validate() {
        let veicolo = this.state.veicolo
        if (veicolo.presenza === "0") {
            for (let i = 0; i < veicolo.tipologiaVeicolo.length; i++) {
                if (veicolo.tipologiaVeicolo[i].livelloCertezzaTipo) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_BF"]), 1
                    )
                } else if (veicolo.tipologiaVeicolo[i].tipologia) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_BE"]), 1
                    )
                } else {
                    for (let j = 0; j < veicolo.tipologiaVeicolo[i].veicolo.length; j++) {
                        if (veicolo.tipologiaVeicolo[i].veicolo[j].veicolo) {
                            return (
                                this.props.aggiungiToaster(
                                    ["Messages.ERR_01_01_0F_BG"]), 1
                            )

                        } else if (veicolo.tipologiaVeicolo[i].veicolo[j].veicoloAltro) {
                            return (
                                this.props.aggiungiToaster(
                                    ["Messages.ERR_01_01_0F_BH"]), 1
                            )

                        } else if (veicolo.tipologiaVeicolo[i].veicolo[j].livelloCertezza) {
                            return (
                                this.props.aggiungiToaster(
                                    ["Messages.ERR_01_01_0F_BI"]), 1
                            )

                        } else if (veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine && veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine.codice) {
                            return (
                                this.props.aggiungiToaster(
                                    ["Messages.ERR_01_01_0F_BL"]), 1
                            )

                        }
                    }
                }
            }
        }
        if (veicolo && veicolo.tipologiaVeicolo) {
            for (let i = 0; i < veicolo.tipologiaVeicolo.length; i++) {
                for (let j = 0; j < veicolo.tipologiaVeicolo[i].veicolo.length; j++) {
                    if (veicolo.tipologiaVeicolo[i].veicolo[j].veicolo && veicolo.tipologiaVeicolo[i].veicolo[j].veicoloAltro && !this.codiceVeicoloIsAltro(veicolo.tipologiaVeicolo[i].veicolo[j].veicolo)) {
                        return (
                            this.props.aggiungiToaster(
                                ["Messages.ERR_01_01_0F_BGTEMP"]), 1
                        )

                    } else if (!veicolo.tipologiaVeicolo[i].veicolo[j].veicolo && veicolo.tipologiaVeicolo[i].veicolo[j].livelloCertezza) {
                        return (
                            this.props.aggiungiToaster(
                                ["Messages.ERR_01_01_0F_BHTEMP"]), 1
                        )
                    }
                    // chiedere conferma specifiche
                    /* else if (veicolo.tipologiaVeicolo[i].veicolo[j].veicolo && veicolo.tipologiaVeicolo[i].veicolo[j].livelloCertezza) {
                        return (
                            this.props.aggiungiToaster(
                                ["Messages.ERR_01_01_0F_BITEMP"]), 1
                        )
                    }*/
                }
            }
        }


        let veicoloNew = JSON.parse(JSON.stringify(this.state.veicolo.tipologiaVeicolo))
        let veicoloUnique = JSON.parse(JSON.stringify(this.state.veicolo))

        for (let i = 0; i < veicoloNew.length; i++) {

            let listaveicoloNew = JSON.parse(JSON.stringify(this.state.veicolo.tipologiaVeicolo[i].veicolo))

            let arraylistaVeicoloPulito = Utils.removeEmptyValueFromObject(listaveicoloNew)
            let arrayNuovolistaVeicolo = Utils.eliminaNullArray(arraylistaVeicoloPulito)

            veicoloUnique.tipologiaVeicolo[i].veicolo = this.uniqueObjectVeicolo(arrayNuovolistaVeicolo, i);
        }

        let objFinal = this.createJsonForBackend(veicoloUnique)
        this.props.setVeicolo(this.state.veicolo, this, objFinal)
    }

    codiceVeicoloIsAltro(codiceVeicolo){
        let isAltro=false
        if (codiceVeicolo==="139"){
            isAltro=true
        }else if (codiceVeicolo==="145"){
            isAltro=true
        }else if (codiceVeicolo==="107"){
            isAltro=true
        }else if (codiceVeicolo==="154"){
            isAltro=true
        }else if (codiceVeicolo==="147"){
            isAltro=true
        }else if (codiceVeicolo==="117"){
            isAltro=true
        }else if (codiceVeicolo==="132"){
            isAltro=true
        }else if (codiceVeicolo==="125"){
            isAltro=true
        }else if (codiceVeicolo==="92"){
            isAltro=true
        }
        return(isAltro)

    }

    uniqueObjectVeicolo(elVeicolo, i) {
        const tmpVeicolo = new Map()

        let veicolo = JSON.parse(JSON.stringify(this.state.veicolo))
        let vuoto = Utils.isEmpty(elVeicolo[0])

        if (!vuoto) {
            const rsVeicolo = elVeicolo.reduce((acc, e) => {
                if (tmpVeicolo.has(e.veicolo) && tmpVeicolo.has(e.veicoloAltro) && tmpVeicolo.has(e.livelloCertezza) && tmpVeicolo.has(e.paeseOrigine.codice)) {
                    if (!tmpVeicolo.get(e.veicolo).includes(e.jobid) && !tmpVeicolo.get(e.veicoloAltro).includes(e.jobid) && !tmpVeicolo.get(e.livelloCertezza).includes(e.jobid) && !tmpVeicolo.get(e.paeseOrigine.codice).includes(e.jobid)) {
                        acc.push(e)
                        tmpVeicolo.set(e.veicolo, [...tmpVeicolo.get(e.veicolo), e.jobid])
                        tmpVeicolo.set(e.veicoloAltro, [...tmpVeicolo.get(e.veicoloAltro), e.jobid])
                        tmpVeicolo.set(e.livelloCertezza, [...tmpVeicolo.get(e.livelloCertezza), e.jobid])
                        tmpVeicolo.set(e.paeseOrigine.codice, [...tmpVeicolo.get(e.paeseOrigine.codice), e.jobid])
                    }
                } else {
                    acc.push(e)
                    tmpVeicolo.set(e.veicolo, [e.jobid])
                    tmpVeicolo.set(e.veicoloAltro, [e.jobid])
                    tmpVeicolo.set(e.livelloCertezza, [e.jobid])
                    tmpVeicolo.set(e.paeseOrigine.codice, [e.jobid])
                }
                return acc
            }, [])

            veicolo.tipologiaVeicolo[i].veicolo = rsVeicolo

            return rsVeicolo
        }

        return veicolo.tipologiaVeicolo[i].veicolo
    }

    createJsonForBackend(veicoloUnique) {
        let veicolo = JSON.parse(JSON.stringify(veicoloUnique ? veicoloUnique : this.state.veicolo));
        let veicoloPulito = {}
        let tipologiaVeicoloPulita = []
        let arrayVeicoloPulito = []
        for (let i = 0; i < veicolo.tipologiaVeicolo.length; i++) {
            arrayVeicoloPulito = []
            let tipologiaVeicoloSingola = Utils.removeEmptyValueFromObject(veicolo.tipologiaVeicolo[i])
            if (veicolo.tipologiaVeicolo[i].veicolo) {
                for (let j = 0; j < veicolo.tipologiaVeicolo[i].veicolo.length; j++) {
                    let paeseOrigine = veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine ?
                        veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine.codice ?
                            veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine.codice :
                            veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine : ""
                    veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine = paeseOrigine
                    let veicoloSingolo = Utils.removeEmptyValueFromObject(veicolo.tipologiaVeicolo[i].veicolo[j])
                    if (!Utils.isEmpty(veicoloSingolo)) {
                        arrayVeicoloPulito.push(veicoloSingolo)
                    }
                }
            }

            if (arrayVeicoloPulito.length > 0) {
                tipologiaVeicoloSingola["veicolo"] = arrayVeicoloPulito
            } else {
                Utils.removeFieldFromObject(tipologiaVeicoloSingola, "veicolo")
            }
            if (!Utils.isEmpty(tipologiaVeicoloSingola)) {
                tipologiaVeicoloPulita.push(tipologiaVeicoloSingola)
            }
        }
        if (tipologiaVeicoloPulita.length > 0) {
            veicoloPulito["tipologiaVeicolo"] = tipologiaVeicoloPulita
        }
        veicoloPulito["presenza"] = this.state.veicolo.presenza
        let objFinal = Utils.removeEmptyValueFromObject(veicoloPulito)
        return objFinal
    }

    controlloCorrettezza() {
        let veicolo = this.state.veicolo
        veicolo.corretto = []

        let controlloDati = {tipologiaVeicolo: false, livelloCertezzaTipoVeicolo: false, veicoloAltro: false, livelloCertezza: false, paeseOrigine: false}
        if (veicolo.presenza === "1") {
            for (let i = 0; i < veicolo.tipologiaVeicolo.length; i++) {
                if (veicolo.tipologiaVeicolo[i].tipologia) {
                    if (!veicolo.tipologiaVeicolo[i].livelloCertezzaTipo && !veicolo.tipologiaVeicolo[i].veicolo[0].veicolo && !controlloDati.livelloCertezzaTipoVeicolo){
                        veicolo.corretto[2] = "Campo \"Livello di certezza tipologia\" mancante"
                        veicolo.corretto[3] = "Campo \"Veicolo\" mancante"
                        controlloDati.livelloCertezzaTipoVeicolo = true
                    }
                }
                else if(!veicolo.tipologiaVeicolo[i].tipologia && !controlloDati.tipologiaVeicolo){
                    veicolo.corretto[1] = "Campo \"Tipologia del veicolo\" mancante"
                    controlloDati.tipologiaVeicolo = true
                }

                if (veicolo.tipologiaVeicolo[i].veicolo) {
                    for (let j = 0; j < veicolo.tipologiaVeicolo[i].veicolo.length; j++) {
                        if (veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "92" || veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "107" ||
                            veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "117" || veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "125" ||
                            veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "132" || veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "139" ||
                            veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "145" || veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "147" ||
                            veicolo.tipologiaVeicolo[i].veicolo[j].veicolo === "154") {
                                    if(!veicolo.tipologiaVeicolo[i].veicolo[j].veicoloAltro && !controlloDati.veicoloAltro){
                                        veicolo.corretto[4] = "Campo \"Veicolo - Altro\" mancante"
                                        controlloDati.veicoloAltro = true
                                    }
                        }
                        if(veicolo.tipologiaVeicolo[i].veicolo[j].veicolo){
                            if(!veicolo.tipologiaVeicolo[i].veicolo[j].livelloCertezza && !controlloDati.livelloCertezza){
                                veicolo.corretto[5] = "Campo \"Livello di certezza\" mancante"
                                controlloDati.livelloCertezza = true
                            }
                            if((!veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine || veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine && !veicolo.tipologiaVeicolo[i].veicolo[j].paeseOrigine.codice) && !controlloDati.paeseOrigine){
                                veicolo.corretto[6] = "Campo \"Paese di origine del veicolo\" mancante"
                                controlloDati.paeseOrigine = true
                            }
                        }
                    }
                }
            }
        }
        else if(!veicolo.presenza) veicolo.corretto[0] = "Campo \"Presenza veicolo\" mancante"

        this.setState({veicolo: veicolo})

        let res = this.createJsonForBackend()
        this.props.setVeicolo(veicolo, this, res)
    }

    riceviValore(field, event) {
        let veicolo = this.state.veicolo;
        let clickSingoloVeicolo
        let clickVeicolo = this.state.clickVeicolo
        let idTipologia
        if (event) {
            if (field.includes("paeseOrigine")) {
                let indici = field.split("sezione");
                idTipologia = parseInt(indici[1])
                let idVeicolo = parseInt(indici[0].replace("paeseOrigine", ""))
                veicolo.tipologiaVeicolo[idTipologia].veicolo[idVeicolo].paeseOrigine = event.target.value

            } else if (field.includes("altro")) {
                let indici = field.split("sezione");
                let idVeicolo = parseInt(indici[1])
                idTipologia = parseInt(indici[0].replace("altro", ""))
                veicolo.tipologiaVeicolo[idTipologia].veicolo[idVeicolo].veicoloAltro = event.target.value
            }
            clickSingoloVeicolo = clickVeicolo[idTipologia] - 1
            clickVeicolo.splice(idTipologia, 1, clickSingoloVeicolo)
            let click = this.state.clickTipologia - 1
            this.setState({veicolo: veicolo, clickTipologia: click, clickVeicolo: clickVeicolo});
            this.aggiungiVeicolo(idTipologia)
            this.controlloCorrettezza()
        }
    }

    aggiungiVeicoloStato(indice) {

        let newVeicolo = {
            veicolo: "",
            veicoloAltro: "",
            livelloCertezza: "",
            paeseOrigine: ""
        }

        let veicolo = this.state.veicolo;
        if (this.state.clickVeicolo[indice] < 3) {
            veicolo.tipologiaVeicolo[indice].veicolo.push(newVeicolo);
            this.setState({veicolo: veicolo});
            this.controlloCorrettezza()
        }
    }

    aggiungiTipologiaStato() {
        let newTipologia = {
            tipologia: "",
            livelloCertezzaTipo: "",
            veicolo: [{
                veicolo: "",
                veicoloAltro: "",
                livelloCertezza: "",
                paeseOrigine: ""
            }
            ]
        }
        let veicolo = this.state.veicolo;
        if (this.state.clickTipologia < 2) {
            veicolo.tipologiaVeicolo.push(newTipologia);
            let listaVeicoli = this.state.listaVeicoli
            let newList = []
            listaVeicoli.push(newList)
            this.setState({veicolo: veicolo, listaVeicoli: listaVeicoli});
            this.controlloCorrettezza()
        }
    }

    handleChangeVeicolo(event, indiceTipologia) {
        let indice = parseInt(event.target.id)
        let clickVeicolo = this.state.clickVeicolo
        let clickSingoloVeicolo = this.state.clickVeicolo[indiceTipologia] - 1
        clickVeicolo.splice(indiceTipologia, 1, clickSingoloVeicolo)
        let click = this.state.clickTipologia - 1
        let tipoVeicolo = this.state.veicolo
        let valueNew = event.target.value
        tipoVeicolo.tipologiaVeicolo[indiceTipologia].veicolo[indice].veicolo = valueNew
        this.setState({veicolo: tipoVeicolo, clickTipologia: click, clickVeicolo: clickVeicolo});
        this.aggiungiVeicolo(indiceTipologia)
        this.controlloCorrettezza()
    }

    handleChangeLivelloCertezzaVeicolo(event, indiceTipologia) {
        let indice = parseInt(event.target.id)
        let clickVeicolo = this.state.clickVeicolo
        let clickSingoloVeicolo = this.state.clickVeicolo[indiceTipologia] - 1
        clickVeicolo.splice(indiceTipologia, 1, clickSingoloVeicolo)
        let click = this.state.clickTipologia - 1
        let tipoVeicolo = this.state.veicolo
        let valueNew = event.target.value
        tipoVeicolo.tipologiaVeicolo[indiceTipologia].veicolo[indice].livelloCertezza = valueNew
        this.setState({veicolo: tipoVeicolo, clickTipologia: click, clickVeicolo: clickVeicolo});
        this.aggiungiVeicolo(indiceTipologia)
        this.controlloCorrettezza()
    }

    eliminaRowVeicolo(tipologiaIndex, veicoloIndex){
        let veicolo = this.state.veicolo.tipologiaVeicolo[tipologiaIndex];
        let boxesVeicolo = this.state.boxesVeicolo
        let clickVeicolo = this.state.clickVeicolo
        veicolo.veicolo.splice(veicoloIndex,1)
        boxesVeicolo[tipologiaIndex].splice(veicoloIndex,1)
        this.setState({clickVeicolo: clickVeicolo, boxesVeicolo: boxesVeicolo, veicolo: veicolo});
        clickVeicolo[tipologiaIndex] = clickVeicolo[tipologiaIndex] - 1
        this.aggiungiVeicolo(tipologiaIndex, clickVeicolo)
    }


    aggiungiVeicolo(indice, clickVeicoloElimina) {
        let listaClickVeicolo = this.state.clickVeicolo
        let clickVeicolo = clickVeicoloElimina && clickVeicoloElimina[indice] ? clickVeicoloElimina[indice] : this.state.clickVeicolo[indice] === this.state.veicolo.tipologiaVeicolo[indice].veicolo.length && this.state.clickVeicolo[indice] ? this.state.clickVeicolo[indice] : this.state.clickVeicolo[indice] ? this.state.clickVeicolo[indice] + 1 : 1
        listaClickVeicolo.splice(indice, 1, clickVeicolo)
        let boxesVeicolo = this.state.boxesVeicolo;
        let boxVeicolo = []
        for (let i = 0; i < clickVeicolo; i++) {
            boxVeicolo.push(
                <div>
                    <div className="row">
                        <div className={`col-lg-6 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.Veicolo.veicolo")}
                                {this.state.veicolo.tipologiaVeicolo[indice].tipologia !== "" && this.state.veicolo.tipologiaVeicolo[indice].livelloCertezzaTipo === "" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""
                                }</p>
                            <Select
                                id={i}
                                value={this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo}
                                onChange={(e) => this.handleChangeVeicolo(e, indice)}
                                functionMap={(this.state.listaVeicoli[indice] && this.state.listaVeicoli[indice].length > 0) ?
                                    this.state.listaVeicoli[indice].map((oggetto) => {
                                        return (<option
                                            value={oggetto.codiceVeicolo}>{oggetto.descrizioneVeicolo}</option>)
                                    }) : ""}
                            >

                            </Select>
                        </div>
                        <div className={`col-lg-5 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.Veicolo.veicoloAltro")}
                                {this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo === "107" ||
                                this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo === "154" ||
                                this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo === "92" ||
                                this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo === "139" ||
                                this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo === "132" ||
                                this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo === "145" ||
                                this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo === "117" ?
                                    <span className={styles.mandatoryColor}>*</span> : ""
                                }</p>
                            <Input id={"altro".concat(indice).concat(i)}
                                   onChange={this.riceviValore}
                                   field={"altro".concat(indice).concat("sezione").concat(i)}
                                   errorMessage={"Veicolo - Altro non valido"}
                                   value={this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicoloAltro}
                                   placeholder={"Veicolo - Altro"}
                            ></Input>
                        </div>
                        <div className={"col-lg-1"}>
                            {
                                i>0 && !(this.props.segnalazioneDatiSpecificiCopia && this.props.segnalazioneDatiSpecificiCopia.migrazione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                    <span id={"veicoloElimina"+i}
                                          onClick={()=>
                                              this.eliminaRowVeicolo(indice, i)

                                          }
                                    ><Icon id={"it-delete"} style={{fill: "red",float: "right", marginTop: "2.4rem", cursor: "pointer"}} /></span>
                                    : <></>
                            }
                        </div>
                    </div>

                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.Veicolo.livello")}
                                {this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo ?
                                    <span className={styles.mandatoryColor}>*</span> : ""
                                }</p>
                            <Select
                                id={i}
                                value={this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].livelloCertezza}
                                onChange={(e) => this.handleChangeLivelloCertezzaVeicolo(e, indice)}
                                functionMap={Utils.mapToArray(OggettiUtili.LivelloDiCertezza).map((oggetto) => {
                                    return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                })}
                            >

                            </Select>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.Veicolo.paese")}
                                {this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].veicolo ?
                                    <span className={styles.mandatoryColor}>*</span> : ""
                                }</p>
                            <div className={styles.fieldContainer}>
                                <Autocomplete
                                    id={"paeseOrigine".concat(indice)}
                                    value={this.state.veicolo.tipologiaVeicolo[indice].veicolo[i].paeseOrigine}
                                    keyField={"codice"}
                                    descriptionField={"descrizione"}
                                    suggestionField={"descrizione"}
                                    onChange={this.riceviValore}
                                    field={"paeseOrigine".concat(i).concat("sezione").concat(indice)}
                                    placeholder={"Paese di origine del veicolo"}
                                    suggestions={this.state.nazioni}

                                >
                                </Autocomplete>
                            </div>
                        </div>
                        <div className={`col-lg-6 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            {i < 1 ? <Button
                                onClick={() => {
                                    this.aggiungiVeicoloStato(indice);
                                    this.aggiungiVeicolo(indice)
                                }}
                                id={"1"}
                                className={styles.testo}
                                classes="btn mt-2 btnBluOutline mb-1 "
                                style={{
                                    marginTop: "3rem", border: "none", background: "none", float: "right",
                                    opacity: (this.props.segnalazioneDatiSpecificiCopia.migrazione || this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "0.5" : ""
                                }}
                                text={this.props.t("DatiSpecifici.Veicolo.aggiungiVeicolo")}
                                icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                disabled={listaClickVeicolo[indice] > 2 || this.props.segnalazioneDatiSpecificiCopia.migrazione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}

                            /> : <div/>}
                        </div>
                    </div>
                </div>
            );
        }
        boxesVeicolo.splice(indice, 1, boxVeicolo)
        let clickTipologia = this.state.clickTipologia - 1
        this.setState({
            clickVeicolo: listaClickVeicolo,
            boxesVeicolo: boxesVeicolo,
            clickTipologia: clickTipologia
        });
        this.controlloCorrettezza()
    }

    eliminaRowTipologia(i){
        let veicolo = this.state.veicolo;
        let boxesTipologia = this.state.boxesTipologia
        let clickTipologia = this.state.clickTipologia
        let clickVeicolo = this.state.clickVeicolo
        clickVeicolo[1] = 0
        veicolo.tipologiaVeicolo.splice(i,1)
        boxesTipologia.splice(i,1)
        this.setState({clickVeicolo: clickVeicolo, boxesTipologia: boxesTipologia, veicolo: veicolo});
        if(i===1) clickTipologia = clickTipologia - 1
        else clickTipologia = clickTipologia - 2
        this.aggiungiTipologia(null, clickTipologia)
    }

    aggiungiTipologia(clickInModifica, clickInElimina) {
        let click = clickInElimina ? clickInElimina : clickInModifica ? clickInModifica : this.state.clickTipologia === this.state.veicolo.tipologiaVeicolo.length ? this.state.clickTipologia : this.state.clickTipologia + 1
        let boxTipologia = []
        for (let i = 0; i < click; i++) {
            boxTipologia.push(
                <div style={{marginTop: "10px"}}>
                    {i > 0 ? <hr className={styles.hr}/> : ""}
                    <div className={"container"}>
                        <div className="row">
                            <div className={`col-lg-6 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                                <p className={styles.testo}>{this.props.t("DatiSpecifici.Veicolo.tipologia")}
                                    {this.state.veicolo.presenza === "1" ?
                                        <span className={styles.mandatoryColor}>*</span> : ""
                                    }
                                </p>
                                <Select
                                    id={i}
                                    value={this.state.veicolo.tipologiaVeicolo[i].tipologia}
                                    onChange={this.handleChangeTipoVeicolo}
                                    functionMap={this.state.listaTipologiaVeicolo[i] ?
                                        this.state.listaTipologiaVeicolo[i].map((oggetto) => {
                                            return (<option
                                                value={oggetto.codiceTipo}>{oggetto.descrizioneTipo}</option>)
                                        }) : ""}>

                                </Select>

                            </div>
                            <div className={`col-lg-3 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <p className={styles.testo}>{this.props.t("DatiSpecifici.Veicolo.livelloTipologia")}
                                    {
                                        this.state.veicolo.tipologiaVeicolo[i].tipologia !== ""
                                        && this.state.veicolo.tipologiaVeicolo[i].veicolo[i === 1 ? i - 1 : 0]?.veicolo === "" ?
                                            <span className={styles.mandatoryColor}>*</span> : ""
                                    }</p>
                                <Select
                                    id={i}
                                    value={this.state.veicolo.tipologiaVeicolo[i].livelloCertezzaTipo}
                                    onChange={this.handleChangeLivelloCertezzaTipologiaVeicolo}
                                    functionMap={Utils.mapToArray(OggettiUtili.LivelloDiCertezza).map((oggetto) => {
                                        return (<option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                    })}>

                                </Select>
                            </div>
                            <div className={`col-lg-3 ${this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                {i < 1 ? <Button
                                    onClick={() => {
                                        this.aggiungiTipologiaStato();
                                        this.aggiungiVeicolo(i + 1)
                                        this.loadTipologiaVeicoli(i + 1)
                                        this.aggiungiTipologia()
                                    }}
                                    className={styles.testo}
                                    classes="btn mt-2 btnBluOutline mb-1 "
                                    style={{
                                        marginTop: "3rem", border: "none", background: "none", float: "right",
                                        opacity: (this.props.segnalazioneDatiSpecificiCopia.migrazione || this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "0.5" : ""
                                    }}
                                    text={this.props.t("DatiSpecifici.Veicolo.aggiungiTipologia")}
                                    icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                    disabled={click > 1 || this.props.segnalazioneDatiSpecificiCopia.migrazione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                /> :
                                    !(this.props.segnalazioneDatiSpecificiCopia && this.props.segnalazioneDatiSpecificiCopia.migrazione || (this.props.segnalazioneDatiSpecificiCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneDatiSpecificiCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                    <span id={"esteroElimina"+i}
                                          onClick={()=>
                                              this.eliminaRowTipologia(i)

                                          }
                                    ><Icon id={"it-delete"} style={{fill: "red",float: "right", marginTop: "2.4rem", cursor: "pointer"}} /></span> : <div></div>
                                }
                            </div>
                        </div>
                        {this.state.boxesVeicolo[i]}
                    </div>
                </div>
            );
        }
        this.setState({clickTipologia: click, boxesTipologia: boxTipologia});
        this.controlloCorrettezza()
    }

    handleChangeTipoVeicolo(event) {

        let indice = event.target.id
        let click = this.state.clickTipologia - 1
        let tipoVeicolo = this.state.veicolo
        let valueNew = event.target.value
        let clickVeicolo = this.state.clickVeicolo
        let clickSingoloVeicolo = this.state.clickVeicolo[indice] - 1
        clickVeicolo.splice(indice, 1, clickSingoloVeicolo)
        tipoVeicolo.tipologiaVeicolo[indice].tipologia = valueNew
        // if (valueNew === "") {
        for (let j = 0; j < tipoVeicolo.tipologiaVeicolo[indice].veicolo.length; j++) {
            tipoVeicolo.tipologiaVeicolo[indice].veicolo[j].veicolo = ""
            tipoVeicolo.tipologiaVeicolo[indice].veicolo[j].veicoloAltro = ""
        }

        // }

        this.setState({veicolo: tipoVeicolo, clickTipologia: click, clickVeicolo: clickVeicolo});
        this.loadSelectVeicolo(valueNew, indice);
        this.controlloCorrettezza()

    }

    handleChangeLivelloCertezzaTipologiaVeicolo(event) {
        let click = this.state.clickTipologia - 1
        let indice = event.target.id
        let tipoVeicolo = this.state.veicolo
        let valueNew = event.target.value
        let clickVeicolo = this.state.clickVeicolo
        let clickSingoloVeicolo = this.state.clickVeicolo[indice] - 1
        clickVeicolo.splice(indice, 1, clickSingoloVeicolo)
        tipoVeicolo.tipologiaVeicolo[indice].livelloCertezzaTipo = valueNew
        this.setState({veicolo: tipoVeicolo, clickTipologia: click});
        this.loadSelectVeicoloCertezzaTipologia(indice);
        this.controlloCorrettezza()
    }


    loadSelectVeicolo(valueNew, indice) {
        let listaVeicoli = this.state.listaVeicoli
        if (valueNew !== "" && this.props.infoMalattia) {
            const v = Utils.groupBy(this.props.infoMalattia, 'codiceTipo')
            listaVeicoli.splice(indice, 1, v[valueNew])
        } else {
            listaVeicoli = listaVeicoli.splice(indice, 1, [])
        }
        this.aggiungiVeicolo(parseInt(indice))
        this.setState({listaVeicoli: listaVeicoli});

    }

    loadSelectVeicoloCertezzaTipologia(indice) {
        let listaVeicoli = this.state.listaVeicoli
        if (this.state.veicolo.tipologiaVeicolo[indice].tipologia !== "" && this.props.infoMalattia) {
            const v = Utils.groupBy(this.props.infoMalattia, 'codiceTipo')
            listaVeicoli.splice(indice, 1, v[this.state.veicolo.tipologiaVeicolo[indice].tipologia])
        } else {
            listaVeicoli = listaVeicoli.splice(indice, 1, [])
        }
        this.aggiungiVeicolo(parseInt(indice))
        this.setState({listaVeicoli: listaVeicoli});
    }

    setPresenzaVeicolo(value) {
        let click = this.state.clickTipologia - 1
        let veicolo = this.state.veicolo
        veicolo.presenza = value
        this.setState({veicolo: veicolo, clickTipologia: click});
        this.controlloCorrettezza()
    }

    render() {
        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{this.props.t("DatiSpecifici.Veicolo.titolo")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <div className="row">
                        <div>
                            <p style={{color: "#1b7ea9", marginLeft: "8px", marginTop: "10px"}}>
                                {this.props.t("DatiSpecifici.Veicolo.presenza")} <span
                                className={styles.mandatoryColor}>*</span>
                            </p>
                        </div>
                        <div style={{marginLeft: "10px"}}>
                            <RadioButton id={"veicolosi"} name={"veicolo"} label={"SI"}
                                         smallLabel={true}
                                         value={"1"}
                                         onClick={this.setPresenzaVeicolo}
                                         checked={this.state.veicolo.presenza === "1"}>

                            </RadioButton>
                        </div>
                        <div style={{marginLeft: "10px"}}>
                            <RadioButton id={"veicolono"} name={"veicolo"}
                                         label={"NO"}
                                         smallLabel={true}
                                         value={"0"}
                                         onClick={this.setPresenzaVeicolo}
                                         checked={this.state.veicolo.presenza === "0"}>
                            </RadioButton>
                        </div>
                                                <div style={{marginLeft: "10px"}}>
                            <RadioButton id={"veicoloNonNoto"} name={"veicolo"}
                                         label={"NON NOTO"}
                                         smallLabel={true}
                                         value={"2"}
                                         onClick={this.setPresenzaVeicolo}
                                         checked={this.state.veicolo.presenza === "2" || this.state.veicolo.presenza === "2*"}
                                         isYellow={!this.props.segnalazioneDatiSpecificiCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneDatiSpecificiCopia.malattia) && this.state.veicolo.presenza === "2*"}
                            >
                            </RadioButton>
                        </div>
                    </div>
                </div>
                {this.state.boxesTipologia}
            </div>)
    }
}

export default withTranslation('common')(Veicolo)
